import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
    AppAlertService,
    AuthenticationService,
    SubtitlesService
} from "../core";
import {ForgotPasswordService} from "../core/forgot-password.service";
import {Subscription} from "rxjs";


@Component({
    selector: 'app-account-activation',
    templateUrl: './account-activation.component.html',
    styleUrls: ['./account-activation.component.scss']
})
export class AccountActivationComponent implements OnInit, OnDestroy {
  isRequesting = false;
  private subtitlesSubscription: Subscription;

  constructor(
      private http: HttpClient,
      private subtitles: SubtitlesService,
      private appAlert: AppAlertService,
      private forgotPassword: ForgotPasswordService,
      private authentication: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.forgotPassword.getUrl();

    if (this.subtitles.downloaded) {
      this.accountActivationAlert();
    } else {
      this.subtitlesSubscription = this.subtitles.subtitlesChanged$.subscribe((newValue) => {
        if (newValue && !this.isRequesting) {
          this.accountActivationAlert();
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.subtitlesSubscription) {
        this.subtitlesSubscription.unsubscribe();
    }
  }

  accountActivationAlert(): void {
    this.isRequesting = true;

    this.http.put(`/api/v1/account/activation/${this.forgotPassword.url_id}`,{}).subscribe({
      next: (response: any) => {
        switch(response['status']) {
          case '0':
            this.appAlert.showAppAlert(
                this.subtitles.setSubtitle(1951) + ' ' + this.subtitles.setSubtitle(4029),
                this.subtitles.setSubtitle(475),
                this.authentication.logout.bind(this.authentication),
                false,
                null
            );
            break;
          case '1':
            this.appAlert.showAppAlert(
                this.subtitles.setSubtitle(1948),
                this.subtitles.setSubtitle(1129),
                this.authentication.logout.bind(this.authentication),
                false,
                null
            );
            break;
          default:
            this.appAlert.showAppAlert(
                this.subtitles.setSubtitle(1951) + ' ' + this.subtitles.setSubtitle(1136),
                this.subtitles.setSubtitle(1136),
                this.authentication.logout.bind(this.authentication),
                false,
                null
            );
        }
      }
    });


  }
}
